'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _facetItem = require('./facet-item');

var _facetItem2 = _interopRequireDefault(_facetItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns bool, indicating whether group should be opened based on props values
 * @param props
 * @param prevState
 */
function getStateByProps(props) {
    var prevState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var hasChecked = false;
    if (props.group && props.group.items && props.group.items.length) {
        hasChecked = props.group.items.filter(function (x) {
            return x.checked;
        }).length > 0;
    }
    return (0, _extends3.default)({}, prevState, { open: hasChecked || !!prevState.open, anySelected: hasChecked });
}

var FacetGroup = function (_React$PureComponent) {
    (0, _inherits3.default)(FacetGroup, _React$PureComponent);

    function FacetGroup(props) {
        (0, _classCallCheck3.default)(this, FacetGroup);

        var _this = (0, _possibleConstructorReturn3.default)(this, (FacetGroup.__proto__ || (0, _getPrototypeOf2.default)(FacetGroup)).call(this, props));

        _this.toggle = function () {
            if (!_this.state.anySelected) {
                _this.setState((0, _extends3.default)({}, _this.state, { open: !_this.state.open }));
            }
        };

        _this.state = getStateByProps(props);
        return _this;
    }

    (0, _createClass3.default)(FacetGroup, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            this.setState(getStateByProps(newProps, this.state));
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;

            var _ref = this.props.group || {},
                name = _ref.name,
                displayName = _ref.displayName,
                items = _ref.items;

            var _state = this.state,
                open = _state.open,
                anySelected = _state.anySelected;

            if (!items || !items.length) return null;
            var groupClass = 'filter__header';
            if (!open) {
                groupClass += ' closed';
            }
            return _react2.default.createElement(
                'div',
                { className: 'filter' },
                _react2.default.createElement(
                    'div',
                    { className: groupClass, onClick: this.toggle },
                    _react2.default.createElement(
                        'h4',
                        { className: 'filter__trigger' },
                        displayName,
                        ' ',
                        !anySelected && _react2.default.createElement('i', { className: 'filter__icon' })
                    )
                ),
                open && _react2.default.createElement(
                    'div',
                    { className: 'filter__content' },
                    items.map(function (item) {
                        return _react2.default.createElement(_facetItem2.default, { key: name + item.value,
                            onChange: self.props.onChange,
                            item: (0, _extends3.default)({ groupName: name, anySelected: anySelected }, item) });
                    })
                )
            );
        }
    }]);
    return FacetGroup;
}(_react2.default.PureComponent);

exports.default = FacetGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/facets/components/facet-group.js
// module id = 412
// module chunks = 0 1